import {
  Card,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { APP_LOCAL_DATE_FORMAT } from "@/config/constants";
import { IEdoFile } from "@/shared/model/edo-file.model";
import { Check, FileText, Image, X } from "lucide-react";
import { useEffect, useState } from "react";
import { TextFormat } from "react-jhipster";
import { SelectFiles } from "./SelectFiles";

export interface SelectFilesDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedFiles: IEdoFile[];
  setSelectedFiles: (files: IEdoFile[]) => void;
}

export const SelectFilesDialog = (props: SelectFilesDialogProps) => {
  const [selectedFilesLocal, setSelectedFilesLocal] = useState<IEdoFile[]>(
    props.selectedFiles
  );

  const { open, handleClose, selectedFiles, setSelectedFiles } = props;

  const handleSubmit = () => {
    setSelectedFiles(selectedFilesLocal);
    handleClose();
  };

  const removeFile = (index: number) => {
    const next = Array.from(selectedFilesLocal);
    next.splice(index, 1);
    setSelectedFilesLocal(next);
  };

  useEffect(() => {
    setSelectedFilesLocal(selectedFiles);
  }, [selectedFiles]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent
        showClose={false}
        className="flex max-h-[90vh] w-full max-w-4xl flex-col gap-0 overflow-hidden bg-[var(--color-surface-secondary)] p-0 dark:bg-[var(--color-surface-secondary)] sm:rounded-2xl"
      >
        <div className="flex shrink-0 items-center justify-between gap-4 border-b border-[var(--color-mockup-border)] px-6 py-4 dark:border-[var(--color-mockup-border)]">
          <h2 className="text-heading font-semibold text-[var(--color-mockup-text)]">
            Seleziona file dall&apos;archivio
          </h2>
          <div className="flex items-center gap-1">
            <IconButton
              onClick={handleClose}
              aria-label="Annulla"
              variant="ghost"
              size="sm"
            >
              <X className="h-4 w-4" />
            </IconButton>
            <IconButton
              onClick={handleSubmit}
              aria-label="Conferma"
              variant="ghost"
              size="sm"
            >
              <Check className="h-4 w-4" />
            </IconButton>
          </div>
        </div>
        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-6 py-5">
          <SelectFiles
            selectedFiles={selectedFilesLocal}
            setSelectedFiles={setSelectedFilesLocal}
            enableUpload={false}
          />
          <Card className="surface overflow-hidden rounded-2xl">
            <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/50 px-4 py-2 dark:border-[var(--color-mockup-border)] dark:bg-[var(--color-surface-secondary)]/30">
              <span className="text-body font-medium text-[var(--color-mockup-text-mid)]">
                Documenti selezionati
              </span>
            </div>
            {selectedFilesLocal?.length ? (
              <List className="divide-y">
                {selectedFilesLocal.map((file: IEdoFile, index: number) => (
                  <ListItem
                    key={file.id}
                    className="flex w-full items-center gap-3 px-4 py-3"
                  >
                    <ListItemIcon>
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--color-surface-secondary)] dark:bg-[var(--color-surface-secondary)]">
                        {file.fileType?.split("/")[0] === "image" ? (
                          <Image className="h-5 w-5 text-[var(--color-mockup-text-mid)] dark:text-[var(--color-mockup-text-light)]" />
                        ) : (
                          <FileText className="h-5 w-5 text-[var(--color-mockup-text-mid)] dark:text-[var(--color-mockup-text-light)]" />
                        )}
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={file.originalFileName}
                      secondary={
                        <TextFormat
                          value={file.createdAt}
                          type="date"
                          format={APP_LOCAL_DATE_FORMAT}
                        />
                      }
                      className="min-w-0 flex-1 truncate"
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        onClick={() => removeFile(index)}
                        aria-label="Rimuovi file"
                        size="sm"
                        variant="ghost"
                      >
                        <X className="h-4 w-4" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            ) : (
              <div className="p-4">
                <p className="text-body text-[var(--color-mockup-text-mid)]">
                  Nessun file selezionato.
                </p>
              </div>
            )}
          </Card>
        </div>
      </DialogContent>
    </Dialog>
  );
};
